import React from "react";

import { css } from "@emotion/css";
import InputAdornment from "@mui/material/InputAdornment";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { contactTypeTranslation } from "@/models/ContactModel.ts";
import { contactTypes } from "@/pages/patient-medical-file/contact-patient/ContactPatient.schema.ts";
import { SelectItem } from "@/uiKit/atoms/inputs/SelectItem.tsx";
import { FormSelectInput } from "@/uiKit/molecules/form/FormSelectInput.tsx";
import { FormSwitchInput } from "@/uiKit/molecules/form/FormSwitchInput.tsx";
import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type InputProps = {
  className?: string;
};

export const SelectRelationshipInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <FormSelectInput
      id="contact-type"
      name="contactType"
      label={t("contact.relationshipWithPatient")}
      classes={{ root: className }}
    >
      {contactTypes.map(value => (
        <SelectItem key={value} value={value}>
          {t(contactTypeTranslation(value))}
        </SelectItem>
      ))}
    </FormSelectInput>
  );
};

export const FirstnameInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <FormTextInput
      id="contact-first-name"
      name="firstName"
      label={t("profile.firstname")}
      classes={{ root: className }}
    />
  );
};

export const LastnameInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <FormTextInput id="contact-last-name" name="lastName" label={t("profile.lastname")} classes={{ root: className }} />
  );
};

export const PhoneInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <FormTextInput
      id="contact-phone"
      name="phone"
      label={t("form.phone.label")}
      classes={{ root: className }}
      startAdornment={
        <InputAdornment position="start">
          <Icons.phone className={styles.icon} />
        </InputAdornment>
      }
      placeholder={"+33"}
    />
  );
};

export const EmailInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <FormTextInput
      id="contact-email"
      name="email"
      label={t("form.email.label")}
      classes={{ root: className }}
      startAdornment={
        <InputAdornment position="start">
          <Icons.email className={styles.icon} />
        </InputAdornment>
      }
      placeholder={t("form.email.label")}
    />
  );
};

export const CommentInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <FormTextInput id="contact-comment" name="comment" label={t("form.text.comment")} classes={{ root: className }} />
  );
};

export const EmergencyContactInput: React.FC<InputProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <FormSwitchInput
      id="contact-emergency"
      name="isEmergencyContact"
      label={t("contact.emergencyContact")}
      size="medium"
      classes={{ root: className }}
    />
  );
};

const makeStyles = () => ({
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
